import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Page404 from './views/Page404';
import Maintenance from './views/Maintenance';
import Home from './views/Home';
import DeviceHeader from './components/header/DeviceHeader'

import Login from './views/auth/Login';
import Logout from './views/auth/Logout';
import Contact from './views/Contact';
import DevicesList from './views/Devices/List';
import privacypolicy from './views/privacypolicy';
import termsofservice from './views/termsofservice';
import Documents from './views/Documents/Documents';
import GroupList from './views/Groups/List';



import AddDevice from './views/Devices/Add';
import DataDevice from './views/Devices/View/Data';
import LogDevice from './views/Devices/View/Log';
import ViewDisplay from './views/Devices/View/Display';
import ControlDevice from './views/Devices/View/Control';
import ActionDevice from './views/Devices/View/Action';
import AddActionDevice from './views/Devices/View/AddAction';
import SettingsDevice from './views/Devices/View/Settings';

import Notifications from './views/Notifications';

function App() {
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, () => {
      setAuthReady(true);
    });
    return () => unsubscribe();
  }, []);

  if (!authReady) {
    return (
      <div className="App">
        <main style={{ textAlign: 'center', padding: '100px 0' }}>
          <h2>Loading...</h2>
        </main>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/privacypolicy" element={<privacypolicy />} />
          <Route path="/termsofservice" element={<termsofservice />} />
          <Route path="/documents/*" element={<Documents />} />

          <Route path="/devices" element={<DevicesList />} />
          <Route path="/devices/add" element={<AddDevice />} />

          <Route path="/devices/view/:id" element={<DeviceHeader />} >
            <Route index element={<ViewDisplay />} />
            <Route path="data" element={<DataDevice />} />
            <Route path="control" element={<ControlDevice />} />
            <Route path="log" element={<LogDevice />} />
            <Route path="action/add" element={<AddActionDevice />} />
            <Route path="action" element={<ActionDevice />} />
            <Route path="settings" element={<SettingsDevice />} />
          </Route>

          <Route path="/groups" element={<GroupList />} />
          <Route path="/group/:id" element={<DevicesList />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
